import { Typography, Grid, withStyles, Theme, useTheme, useMediaQuery } from '@material-ui/core'
import suggestIcon from '../../../../images/suggest.svg'
import { MuiClasses } from '../../../../types'
type SuggestProps = {
  classes: MuiClasses
  content?: string
  containerMaxWidth?: string
  contentMaxWidth?: string
  isModal?: boolean
  bigPaddingOnLargeScreens?: boolean,
  mediumPaddingOnLargeScreens?: boolean
}
const styles = ({ breakpoints }: Theme) => ({
  largeForm: {
    padding: '35px 0 15px 0',
    display: 'flex',
    justifyContent: 'center',
    justifySelf: 'center',
    margin: 'auto',
    [breakpoints.down('sm')]: {
      padding: '10px 0'
    },
    [breakpoints.up('lg')]: {
      display: 'flex'
    }
  },
  suggestContainer: {
    background: '#FBF6EE',
    padding: '25px 40px',
    display: 'flex',
    fontSize: '12px',
    borderRadius: '25px',
    // '> div': {
    //   display: 'flex'
    // },
    [breakpoints.up('xs')]: {
      padding: '25px'
    },
    '& img': {
      marginRight: '10px',
      marginBottom: '10px'
    }
  },
  suggestIcon: {
    float: 'left' as const,
    padding: '5px'
  },
  suggestText: {
    textAlign: 'left' as const,
    [breakpoints.up('md')]: {
      overflow: 'hidden'
    }
  }
})

const Suggest = ({
  classes,
  content,
  containerMaxWidth,
  contentMaxWidth,
  isModal,
  bigPaddingOnLargeScreens,
  mediumPaddingOnLargeScreens
}: SuggestProps) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <div
      className={classes.largeForm}
      style={{
        maxWidth: containerMaxWidth || '650px'
      }}
    >
      <Grid
        container
        className={classes.suggestContainer}
        style={{ flexWrap: 'nowrap', maxWidth: contentMaxWidth || '450px',
          ...(bigPaddingOnLargeScreens && isLargeScreen && {
            padding: '50px 40px'
          }),
          ...(mediumPaddingOnLargeScreens && isLargeScreen && {
            padding: '30px 25px'
          }),
      }}
      >
        {!isModal && (
          <Grid item>
            <img src={suggestIcon} />
          </Grid>
        )}
        <Grid item>
          {isModal && <img src={suggestIcon} className={classes.suggestIcon} />}
          <Typography
            variant='body2'
            className={classes.suggestText}
            style={{ whiteSpace: 'pre-line' }}
          >
            {content ||
              `Lorem ipsum dolor sit amet consectetur adipisicing elit. Minus
            obcaecati, suscipit corporis fugit voluptates voluptatum impedit
            fugiat nulla voluptas numquam magni laborum unde iure ullam veniam.
            Dignissimos ut reprehenderit ex!`}
          </Typography>
        </Grid>
      </Grid>
    </div>
  )
}
export default withStyles(styles)(Suggest)
